import { CategoryCombo, TextFilter, HistoricalComboAthlete } from 'src/app/common-page-components/stores/filters-store/filters-store';
import { combineLatest, BehaviorSubject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { FiltersAbstractService } from '../../../../common-page-components/classes/filters-abstract-service';
import { Router } from '@angular/router';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "@angular/router";
/**
 * Provides filters for atheletes in a member association.
 *
 * @export
 * @class MembersAthletesFiltersServiceService
 * @extends {FiltersAbstractService}
 */
export class MembersAthletesFiltersServiceService extends FiltersAbstractService {
    /**
     * Creates an instance of MembersAthletesFiltersServiceService.
     *
     * @param {HttpClient} http
     * @memberof MembersAthletesFiltersServiceService
     */
    constructor(http, router) {
        super();
        this.http = http;
        this.router = router;
        this.countryCode = new BehaviorSubject('all');
        this.categoryCombo = new CategoryCombo('Categories:', 'categorycombo', this.http, [{ item: { Name: 'All' }, position: 0 }]);
        this.textFilter = new TextFilter('searchinput');
        this.activeCombo = new HistoricalComboAthlete('Current', 'currentcombo', undefined, [{ item: { Name: 'Active and inactive' }, position: 0 }, { item: { Name: 'Active' }, position: 1 }, { item: { Name: 'Inactive' }, position: 2 }]);
        this.filtersType = [
            this.textFilter.filterInfo,
            this.categoryCombo.filterInfo,
            this.activeCombo.filterInfo,
        ];
    }
    /**
     * {@inheritdoc}
     *
     * @memberof MembersSearchFiltersService
     */
    generateDefaultValues() { }
    /**
     * {@inheritdoc}
     *
     * @returns
     * @memberof MembersSearchFiltersService
     */
    getDataStreamWithFilters() {
        return combineLatest([this.orderValue,
            this.textFilter.data(),
            this.categoryCombo.comboData,
            this.activeCombo.comboData,
            this.countryCode.asObservable()
        ]);
    }
}
MembersAthletesFiltersServiceService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function MembersAthletesFiltersServiceService_Factory() { return new MembersAthletesFiltersServiceService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.Router)); }, token: MembersAthletesFiltersServiceService, providedIn: "root" });
